module.exports = __webpack_public_path__ + "img/slide_2.ae76a82c.webp";